import { createContext, useContext, useState, useCallback } from 'react';

const WalletModalContext = createContext(null);

export function WalletModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openWallet = useCallback(() => setIsOpen(true), []);
  const closeWallet = useCallback(() => setIsOpen(false), []);

  return (
    <WalletModalContext.Provider value={{ isOpen, openWallet, closeWallet }}>
      {children}
    </WalletModalContext.Provider>
  );
}

export function useWalletModal() {
  const ctx = useContext(WalletModalContext);
  if (!ctx) {
    throw new Error('useWalletModal must be used inside WalletModalProvider');
  }
  return ctx;
}